import { Component, OnInit } from "@angular/core";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { UsuarioService } from "src/app/core/services/usuario-service";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { PedidoService } from "src/app/core/services/pedido-service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead";
import { CurrencyPipe } from "@angular/common";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ProductService } from "src/app/core/services/product-service";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { InitProvider } from "src/app/core/services/init-provider";
import { formatDate } from "@angular/common";
import { DateRangeFactoryService } from "src/app/core/services/date-range-factory.service";
import { DateRangeOption } from "src/app/core/interfaces/date-range";
import { RelatorioService } from "src/app/core/services/relatorios.service";
import "@angular/localize/init";
import { Router } from "@angular/router";
declare var $: any;

type Boleto = {
  lancamento: number;
  cliente: number;
  numeroDocumento: string;
  nossoNumero: string;
  dataVencimento: string;
  valorBoleto: number;
  sacadoNome: string;
  sacadoCnpj: string;
  sacadoCep: string;
  sacadoBairro: string;
  sacadoLogradouro: string;
  sacadoCidade: string;
  sacadoEstado: string;
  codBanco: string;
  conta: string;
  agencia: string;
  carteira: string;
  dataEmissao: string;
  cedenteNome: string;
  cedenteCnpj: string;
  instrucao1: string;
  instrucao2: string;
  instrucao3: string;
  ativo: boolean;
};
@Component({
  selector: "app-page-vendas",
  templateUrl: "./page-vendas.component.html",
  styleUrls: ["./page-vendas.component.css"],
})
export class PageVendasComponent implements OnInit {
  public list: number = 0;
  usuarios: Observable<any[]>;
  typingUsuario: string;

  // private format = new DateFormatter();
  tipo = "analitico";
  nivelAcesso: any;
  elementos;
  vendas: any[] = [];
  filiais: any[] = [];
  clienteSelecionado: number = 0;
  nomeRepresentante = "";
  formaPagamento = "";
  public notasPedido = [];
  public pedidosCliente = [];
  selectedIds: number[] = []; // Array para armazenar os IDs selecionados
  tabelas: any[] = [];
  precos: any[] = [];
  pagTotaisErp = 0;
  public clienteSelecionadoPedidos: any = {
    codigo: "",
    limite_credito: null,
    nome: "",
    fantasia: "",
    cnpj: "",
    cidades: {
      nome: "",
      uf: "0",
    },
  };
  descontoId: number;
  estoque: any[] = [];
  pageCliente = 1;
  pageable: boolean = true;
  public loadPdf: boolean = false;
  public formSearch: FormGroup;
  pedidos: any[] = [];
  pageNumber = 1;
  dataCliente;
  public mapItens;
  public mapProdutos;
  pagTotais: number = 0;
  pagTotaisNotas: number = 0;
  public tablePedidoView;
  totalElements: 0;
  totalElementsErp: 0;
  totalElementsNotas: 0;
  pagTotaisBoletos: number = 0;
  boletosCliente: any[] = [];
  totalElementsBoletos: number = 0;
  qrCode: any = {};
  pedido: any;
  pedidoAprove: any;
  nome: string;
  pageOrder: number = 0;
  pageNumberNotas: number = 1;
  pageNumberERP: number = 1;
  pageNumberBoletos: number = 1;
  descontoValor = 0;
  typingCliente: string;
  clientes: Observable<any[]>;
  public orderItens: any[] = [];
  SITE: ConfiguracoesSite;
  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
  public ranges: DateRangeOption[];
  totalPages = 0;

  constructor(
    private localeService: BsLocaleService,
    public usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private rangeFactory: DateRangeFactoryService,
    public pedidoService: PedidoService,
    private router: Router,
    private sanitizer: DomSanitizer,
    public productService: ProductService,
    public initProvider: InitProvider,
    public relatorioService: RelatorioService,
    private toastService: ToastrService
  ) {
    this.SITE = Configuracoes.SITE;
    this.localeService.use("pt-custom");
    this.formSearch = this.formBuilder.group({
      data: [[]],
      cliente: [""],
      filial: [""],
      sku: [""],
      tabela: [""],
      produto: [""],
      status: [""],
      usuario: [""],
      pedido: [""],
      tipo: ["analitico"],
    });
    this.usuarios = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getUsuarios(
          this.typingUsuario,
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });
    this.clientes = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getClientes(
          {
            busca: this.typingCliente,
            id_usuario: this.initProvider.usuario.id,
          },
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });
    this.elementos =
      this.initProvider.usuario.nivel
        .find((n) => n.titulo === "Historico")
        ?.elementos.filter((i) => i.listar) || [];
  }

  ngOnInit(): void {
    this.ranges = this.rangeFactory.getVendasRanges();
  }
  onSelectCliente(event: TypeaheadMatch): void {
    this.formSearch.controls.cliente.setValue(event.item.id);
    $("#cliente").blur();
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-valid");
    $("#btnFormSearch").focus();
  }

  onSelectClientePedidos(event: TypeaheadMatch): void {
    this.clienteSelecionadoPedidos = event.item;
    $("#cliente2").blur();
    $("#cliente2").removeClass("is-valid is-invalid");
    $("#cliente2").addClass("is-valid");
    $("#btnFormSearch").focus();
    const item = event.item;
    delete item.bloqueiaPedidos;
    this.selecionaCliente(event.item);
    this.clienteSelecionado = event.item.iderp;
    this.typingCliente = "";
    this.getPedidoErp(this.clienteSelecionado, 1);
    this.getPedidoNotas(this.clienteSelecionado, 1);
    this.getBoletos(this.clienteSelecionado, 1);
  }

  selecionaCliente(cliente: any) {
    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        this.clienteSelecionadoPedidos = resp;
      }
    );
  }
  typeaheadNoResultsPedidos(event: boolean): void {
    //if(event){
    this.formSearch.controls.cliente.setValue("");
    $("#cliente2").removeClass("is-valid is-invalid");
    $("#cliente2").addClass("is-invalid");
    //}
  }
  typeaheadNoResults(event: boolean): void {
    //if(event){
    this.formSearch.controls.cliente.setValue("");
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-invalid");
    //}
  }

  printNota(nota) {
    if (nota === undefined) {
      this.toastService.warning(
        $localize`Pedido sem nota fiscal associada`,
        $localize`Nota fiscal`
      );
      return;
    }
    window.open(Configuracoes.API_DOCS + nota.link, "_blank");
    // this.downloadFile(nota.link, nota.id+ ' - '+nota.tipo)
  }

  setPage(value) {
    this.nivelAcesso = value;
    this.list = value.ordem;
    this.pageNumber = 1;
    if (value.ordem === 3) {
      // this.getEstoque(true)
      this.usuarioService.getFiliais(100, (e) => {
        this.filiais = e;
      });
    }
    if (value.ordem === 4) {
      // this.getPedidos()
    }
    if (value.ordem === 5) {
      // this.getPreco(true)
      this.usuarioService.getTabelas(100, (e) => {
        this.tabelas = e;
      });
    }
  }
  onSubmit() {}

  getSafeImageUrl() {
    // Certifique-se de qrCode.image_qrcode contém a string base64 da imagem
    if (this.qrCode.image_qrcode) {
      const imageUrl = "data:image/png;base64," + this.qrCode.image_qrcode;
      return this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
    }
  }
  pageChanged(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getEstoque();
    }
  }

  pageChangedPreco(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getPreco();
    }
  }

  pageOrderChanged(e) {
    if (this.pageOrder !== e.page) {
      this.pageOrder = e.page;
      this.getPedidos();
    }
  }
  replaceString(s) {
    if (s == null) {
      return "";
    }
    return s.replace("_", " ");
  }

  getPedidoNotas(id, page = 1) {
    // if(this.clienteSelecionadoPedidos === undefined){
    //   this.toastService.error(
    //     $localize`Selecione um cliente`,
    //     $localize`Notas`,
    //     {
    //       timeOut: 4000,
    //     }
    //   );
    //   return
    // }
    let data: any = {};
    if (this.dataCliente !== undefined) {
      data["dataInicial"] = formatDate(this.dataCliente[0], "dd/MM/yyyy", "en");
      data["dataFinal"] = formatDate(this.dataCliente[1], "dd/MM/yyyy", "en");
    }
    if (id === 0) {
      this.toastService.warning("Selecione um cliente", "Notas");
      return;
    }
    this.pedidoService.getPedidoNotas(
      { cliente: id, pagina: page - 1, ...data },
      function (response) {
        if (response.total_elementos > 0) {
          this.pagTotaisNotas = response.paginas;
          this.notasPedido = response.lista_notas;
          this.totalElementsNotas = response.total_elementos;
        } else {
          this.pagTotaisNotas = 0;
          this.notasPedido = [];
          this.totalElementsNotas = 0;
        }
      }.bind(this)
    );
  }
  pageChangedReps(e) {
    console.log(e);
  }

  changePageERP(e) {
    this.getPedidoErp(this.clienteSelecionado, e.page);
  }

  changePageNotas(e) {
    this.getPedidoNotas(this.clienteSelecionado, e.page);
  }

  changePageBoletos(e) {
    this.getBoletos(this.clienteSelecionado, e.page);
  }

  getPedidoErp(id, page = 1) {
    let data: any = {};
    if (this.dataCliente !== undefined) {
      data["dataInicial"] = formatDate(this.dataCliente[0], "dd/MM/yyyy", "en");
      data["dataFinal"] = formatDate(this.dataCliente[1], "dd/MM/yyyy", "en");
    }
    // if(this.clienteSelecionadoPedidos === undefined){
    //   this.toastService.error(
    //     $localize`Selecione um cliente`,
    //     $localize`Notas`,
    //     {
    //       timeOut: 4000,
    //     }
    //   );
    //   return
    // }
    if (id === 0) {
      this.toastService.warning("Selecione um cliente", "Pedidos");
      return;
    }
    this.pedidoService.getPedidoErp(
      { cliente: id, pagina: page - 1, ...data },
      function (response) {
        if (response.total_elementos > 0) {
          this.pagTotaisErp = response.paginas;
          this.pedidosCliente = response.lista_pedidos;
          this.totalElementsErp = response.total_elementos;
        } else {
          this.pagTotaisErp = 0;
          this.pedidosCliente = [];
          this.totalElementsErp = 0;
        }
      }.bind(this)
    );
  }

  getBoletos(id, page = 1) {
    let data: any = {};
    if (this.dataCliente !== undefined) {
      data["dataInicial"] = formatDate(this.dataCliente[0], "YYYY-MM-DD", "en");
      data["dataFinal"] = formatDate(this.dataCliente[1], "YYYY-MM-DD", "en");
    }

    if (id === 0) {
      this.toastService.warning("Selecione um cliente", "Boletos");
      return;
    }
    this.pedidoService.getBoletos(
      { cliente: id, pagina: page - 1, ...data },
      function (response) {
        if (response.total_elementos > 0) {
          this.pagTotaisBoletos = response.paginas;
          this.boletosCliente = response.lista_boletos;
          this.totalElementsBoletos = response.total_elementos;
        } else {
          this.pagTotaisBoletos = 0;
          this.boletosClienteCliente = [];
          this.totalElementsBoletos = 0;
        }
      }.bind(this)
    );
  }

  printBoletoPdf(boleto: Boleto) {
    const headers = new Headers({
      Branch: Configuracoes.API_BRANCH,
      Authorization: "Bearer " + window.localStorage.getItem("token"),
      "Content-Type": "application/json",
    });

    fetch(
      `${Configuracoes.API}impressoes/boleto?pedido=${boleto.numeroDocumento}&lancamento=${boleto.lancamento}`,
      {
        method: "GET",
        headers,
      }
    )
      .then((response) => response.json()) // 👈 aqui vem o JSON
      .then((jsonResposta) => {
        // agora envia esse JSON para a outra requisição
        this.relatorioService.getBoletoPdf(
          jsonResposta,
          (pdf) => {
            window.open(pdf.arquivo);
          },
          (erro) => {
            console.error("Erro ao gerar PDF", erro);
          }
        );
      })
      .catch((err) => {
        console.error("Erro ao buscar dados do boleto", err);
      });
  }

  getIdPedido(pedido) {
    if (!pedido.reservado_erp) {
      this.toastService.error(
        $localize`Não é possivel aprovar um pedido com reserva pendente`,
        $localize`Vendas`,
        {
          timeOut: 4000,
        }
      );
      return null;
    }
    if (
      pedido.status_pagamento !== "pos_pago" &&
      pedido.status_pagamento !== "pre_pago"
    ) {
      this.toastService.error(
        $localize`Não é possivel aprovar um pedido aguardando pagamento`,
        $localize`Vendas`,
        {
          timeOut: 4000,
        }
      );
      return null;
    }
    if (
      pedido.limite_credito !== null &&
      pedido.limite_credito < pedido.total &&
      pedido.status_pagamento !== "pre_pago"
    ) {
      this.toastService.error(
        $localize`Valor do pedido excede o limite de crédito`,
        $localize`Vendas`,
        {
          timeOut: 4000,
        }
      );
      return null;
    }
    $("#confirmAprovaModal").modal("show");
    this.nome = pedido.numero_pedido;
    // this.pedido = pedido
    this.formaPagamento = pedido.descricao_formapagamento;
    this.nomeRepresentante = pedido.nome_representante;
    this.pedidoAprove = pedido;
  }

  disableCheckbox(pedido) {
    if (!pedido.reservado_erp) {
      return false;
    }
    if (pedido.status_pagamento !== "pos_pago") {
      return false;
    }
    if (
      pedido.limite_credito !== null &&
      pedido.limite_credito < pedido.total
    ) {
      return false;
    }
    if (pedido.status_pagamento === "pre_pago") {
      return false;
    }
    return true;
  }
  showPedidoFinalizado(p: any) {
    this.pedidoService.pedidoCliente(p.numero_pedido, (res) => {
      this.pedido = res;
      this.mapaItensEProdutos();
      this.tablePedidoView = "";
      this.orderItens = res.itens;
    });
  }

  public redirectToRastreio(p) {
    if (p.link_frete) window.open(p.link_frete, "_blank").focus();
    else this.toastService.warning($localize`Sem rastreio associado ao pedido`);
  }

  onFilterPedidos() {
    if (this.pageCliente === 0) {
      this.toastService.warning("Selecione um relatorio", "Relatorios");
    }
    this.pageNumberNotas = 1;
    this.pageNumberERP = 1;
    this.pageNumberBoletos = 1;
    //  if (this.pageCliente === 1) {
    this.getPedidoErp(this.clienteSelecionado);
    // } else if (this.pageCliente === 2) {
    this.getPedidoNotas(this.clienteSelecionado);
    this.getBoletos(this.clienteSelecionado);
    // }
  }

  setPageCliente(page) {
    this.pageNumber = 1;
    this.pageCliente = page;
  }
  table1(produto, itens) {
    let mapCor = {};
    itens.forEach((i) => {
      if (mapCor[i.cor]) {
        mapCor[i.cor].push(i);
      } else {
        mapCor[i.cor] = [i];
      }
    });
    let head = "<tr><td>COR</td>";
    let rows = [];
    let totalTamanhos = {};
    let totalQtde = 0;
    let totalPreco = 0;
    let totalTotal = 0;
    for (let key of Object.keys(mapCor)) {
      let grade = "<tr><td>" + mapCor[key][0].corDescricao + "</td>";
      let qtde = 0;
      let total = 0;
      produto.tamanhos.forEach((t) => {
        let tamanho = 0;
        mapCor[key].forEach((mC) => {
          if (mC.tamanho == t.tamanho) {
            tamanho = mC.quantidade;
            qtde += mC.quantidade;
            total += mC.total;
            if (totalTamanhos[t.tamanho]) {
              totalTamanhos[t.tamanho] += mC.quantidade;
            } else {
              totalTamanhos[t.tamanho] = mC.quantidade;
            }
          }
        });
        grade += "<td>" + tamanho + "</td>";
      });
      totalQtde += qtde;
      totalPreco += total / qtde;
      totalTotal += total;
      grade += "<td>" + qtde + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total / qtde, "", "") + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total, "", "") + "</td></tr>";
      rows.push(grade);
    }
    let grade = "<tr><td></td>";
    produto.tamanhos.forEach((t) => {
      grade +=
        "<td>" +
        (totalTamanhos[t.tamanho] ? totalTamanhos[t.tamanho] : "") +
        "</td>";
    });
    grade += "<td><b>" + totalQtde + "</b></td>";
    grade +=
      "<td><b>" + this.currencyPipe.transform(totalPreco, "", "") + "</b></td>";
    grade +=
      "<td><b>" +
      this.currencyPipe.transform(totalTotal, "", "") +
      "</b></td></tr>";
    rows.push(grade);
    produto.tamanhos.forEach((t) => {
      head += "<td>" + t.tamanho + "</td>";
    });
    head += "<td>QTDE</td>";
    head += "<td>PREÇO</td>";
    head += "<td>TOTAL</td></tr>";
    return `<div class="table-responsive">
      <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
        <thead class="table-head">
            <tr>
                <th colspan="5">${produto.referencia} - ${
      produto.descricao
    }</th>
            </tr>
        </thead>
        <tbody>
            ${head}
            ${rows.join("")}
        </tbody>
      </table>
    </div>`;
  }
  mapaItensEProdutos() {
    this.mapItens = {};
    this.pedido.itens.forEach((i) => {
      if (this.mapItens[i.produto]) {
        this.mapItens[i.produto].push(i);
      } else {
        this.mapItens[i.produto] = [i];
      }
    });
    this.mapProdutos = {};
    this.pedido.itens.forEach((i) => {
      this.mapProdutos[i["produto"] as any] = null;
    });
  }
  getPix(id) {
    this.usuarioService.getPix(
      {
        pedido_cliente: id,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
      }.bind(this),
      function (resp) {
        this.toastService.info($localize`Algo deu errado!`, "Pix", {
          timeOut: 4000,
        });
      }.bind(this)
    );
  }
  consultaPix(id) {
    this.usuarioService.consultaPix(
      {
        pedido_cliente: id,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
      }.bind(this),
      function (resp) {
        let res = resp._body;
        this.toastService.info(JSON.parse(res).detail, "Pix", {
          timeOut: 4000,
        });
      }.bind(this)
    );
  }

  aplicaDesconto(id) {
    this.descontoId = id;
    $("#descontoModal").modal("show");
  }
  sort1(a, b) {
    if (a.ref.toLowerCase() > b.ref.toLowerCase()) {
      return 1;
    } else if (a.ref.toLowerCase() < b.ref.toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  }
  agruparPorProdutoReferencia(data) {
    const agrupado = {};

    data.forEach((item) => {
      const referencia = item.produtoReferencia;
      if (!agrupado[referencia]) {
        agrupado[referencia] = [];
      }
      agrupado[referencia].push(item);
    });
    return Object.keys(agrupado).map((key) => {
      const firstItem = agrupado[key][0]; // Pega o primeiro item do grupo
      return {
        produtoReferencia: firstItem.produtoReferencia,
        descricao: firstItem.descricao, // Usa a descrição do primeiro item
        itens: agrupado[key],
      };
    });
  }
  sumQtd(itens) {
    return itens.reduce(
      (accumulator, object) => accumulator + object.quantidade,
      0
    );
  }
  sumPrc(itens) {
    return itens.reduce((accumulator, object) => accumulator + object.total, 0);
  }
  getVendas() {
    if (
      this.formSearch.value.data &&
      this.formSearch.value.data[0] &&
      this.formSearch.value.data[1]
    ) {
      this.formSearch["dataI"] = formatDate(
        this.formSearch.value.data[0],
        "DD/MM/YYYY",
        "en"
      );
      this.formSearch["dataF"] = formatDate(
        this.formSearch.value.data[1],
        "DD/MM/YYYY",
        "en"
      );
    }
    if (this.formSearch.status === "INVALID") {
      Swal.fire($localize`Vendas`, $localize`Escolha uma data`, "error");
      return;
    }

    this.usuarioService.listaVendas(
      this.formSearch,
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }
  callback(resp) {
    if (this.list === 2) {
      this.vendas = resp;
      if (resp.length === 0) {
        this.toastService.info(
          $localize`Nenhum registro encontrado`,
          $localize`Vendas`,
          {
            timeOut: 4000,
          }
        );
      }
    } else if (this.list == 4) {
      this.pedidos = resp;
      this.pagTotais = resp[0].paginas;
      this.totalElements = resp[0].total_elementos;
      this.totalPages = resp[0].paginas;
      if (resp.length === 0) {
        this.toastService.info(
          $localize`Nenhum registro encontrado`,
          $localize`Pedidos`,
          {
            timeOut: 4000,
          }
        );
      }
    } else if (this.list == 3) {
      this.estoque = resp.estoque;
      // if (resp.length > 0) {
      //   resp[0];
      this.pagTotais = resp.paginas;
      this.totalElements = resp.totalElements;
      // }
      if (resp.length === 0) {
        this.toastService.info(
          $localize`Nenhum registro encontrado`,
          $localize`Estoque`,
          {
            timeOut: 4000,
          }
        );
      }
    } else if (this.list == 5) {
      this.precos = resp.clientes;
      this.pagTotais = resp.paginas;
      this.totalElements = resp.total_elementos;
      if (resp.length === 0) {
        this.toastService.info(
          $localize`Nenhum registro encontrado`,
          $localize`Preços`,
          {
            timeOut: 4000,
          }
        );
      }
    }
  }
  callbackError(resp) {
    if (resp.status && resp.status === 403) {
      this.router.navigate(["/login"]).then(() => {
        window.location.reload();
      });
      this.toastService.warning(
        $localize`Usuario não autenticado`,
        $localize`Representante`,
        {
          positionClass: "toast-bottom-left",
        }
      );
    }
    if (resp._body) {
      if (JSON.parse(resp._body).detail) {
        Swal.fire(
          $localize`Histórico`,
          JSON.parse(resp._body).detail,
          "warning"
        );
      } else {
        Swal.fire(
          $localize`Histórico`,
          $localize`Algo deu errado. Tente novamente mais tarde`,
          "warning"
        );
      }
    } else {
      Swal.fire(
        $localize`Histórico`,
        $localize`Algo deu errado. Tente novamente mais tarde`,
        "warning"
      );
    }
  }

  getEstoque(filtra = false) {
    if (filtra) {
      this.pageNumber = 1;
    }
    this.tipo = this.formSearch.value.tipo;
    this.usuarioService.getEstoque(
      { ...this.formSearch.value, page: this.pageNumber },
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  getPreco(filtra = false) {
    if (filtra) {
      this.pageNumber = 1;
    }
    this.tipo = this.formSearch.value.tipo;
    this.usuarioService.getPreco(
      { ...this.formSearch.value, page: this.pageNumber },
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  getPedidos() {
    console.log(this.formSearch.value.pedido);
    let data: any = {
      page: this.pageOrder,
      tipo:
        this.formSearch.value.status === ""
          ? "TODOS"
          : this.formSearch.value.status,
    };
    data.cliente = this.formSearch.value.cliente;
    data.usuario = this.formSearch.value.usuario;
    data.pedido = this.formSearch.value.pedido;
    if (this.formSearch.value.data && this.formSearch.value.data.length > 0) {
      data["dataInicial"] = formatDate(
        this.formSearch.value.data[0],
        "yyyy-MM-dd", // CORRETO
        "en"
      );
      data["dataFinal"] = formatDate(
        this.formSearch.value.data[1],
        "yyyy-MM-dd", // CORRETO
        "en"
      );
    }
    this.pedidoService.listaPedidoV2(data, this.callback.bind(this));
    // this.usuarioService.listaRepresentante(
    //   this.form.value,
    //   this.callback.bind(this),
    //   this.callbackError.bind(this)
    // );
  }
  exportToExcel(fileName: string): void {
    function callback(resp) {
      let list = [];
      list = resp.estoque;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, fileName + ".xlsx");
    }
    this.usuarioService.getEstoque(
      { ...this.formSearch.value, page: 0 },
      callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  exportPriceToExcel(fileName: string): void {
    function callback(resp) {
      let list = [];
      list = resp.clientes;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, fileName + ".xlsx");
    }
    this.usuarioService.getPreco(
      { ...this.formSearch.value, page: 0 },
      callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  copyLink(link) {
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          $localize`Link copiado com sucesso para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        this.toastService.warning(
          $localize`Erro ao copiar link para a área de transferência`,
          $localize`Produto`,
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  callbackAprove(resp) {
    Swal.fire($localize`Pedido`, $localize`Aprovado com sucesso!`, "success");
    this.getPedidos();
  }
  callbackAprovePix(resp) {
    this.getPedidos();
  }
  callbackReprove(resp) {
    Swal.fire($localize`Pedido`, $localize`Recusado com sucesso!`, "success");
    this.getPedidos();
  }
  callbackDevolve(resp) {
    Swal.fire(
      $localize`Pedido`,
      $localize`Pedido devolvido para digitação`,
      "success"
    );
    this.getPedidos();
  }
  aprovaPedido(order) {
    if (this.pedidoAprove.status_pagamento === "pre_pago") {
      this.usuarioService.getPix(
        {
          pedido_cliente: this.pedidoAprove.numero_pedido,
        },
        function (resp) {
          this.pedidoService.aprovarPedido(
            order,
            true,
            this.callbackAprovePix.bind(this),
            this.callbackError.bind(this)
          );
          this.qrCode = resp;
          $("#pixModal").modal("show");
        }.bind(this),
        function (resp) {
          if (resp._body) {
            if (JSON.parse(resp._body).detail) {
              Swal.fire(
                $localize`Histórico`,
                JSON.parse(resp._body).detail,
                "warning"
              );
            } else {
              this.toastService.info(
                $localize`Não foi possivel aprovar esse pedido! Algo deu errado!'`,
                `Pix`,
                {
                  timeOut: 4000,
                }
              );
            }
          } else {
            this.toastService.info(
              $localize`Não foi possivel aprovar esse pedido! Algo deu errado!'`,
              `Pix`,
              {
                timeOut: 4000,
              }
            );
          }
        }.bind(this)
      );
    } else {
      this.pedidoService.aprovarPedido(
        order,
        true,
        false,
        this.callbackAprove.bind(this),
        this.callbackError.bind(this)
      );
    }
  }
  reprovaPedido(order) {
    this.pedidoService.aprovarPedido(
      order,
      false,
      false,
      this.callbackReprove.bind(this),
      this.callbackError.bind(this)
    );
  }
  devolveParaDigitacao(order) {
    this.pedidoService.aprovarPedido(
      order,
      false,
      true,
      this.callbackDevolve.bind(this),
      this.callbackError.bind(this)
    );
  }
  isSelected(id: number): boolean {
    return this.selectedIds.includes(id);
  }

  toggleSelection(event: any, id: number): void {
    if (event.target.checked) {
      this.selectedIds.push(id);
    } else {
      this.selectedIds = this.selectedIds.filter((item) => item !== id);
    }
  }

  toggleSelectAll(event: any): void {
    if (event) {
      // Adiciona apenas os IDs dos itens que não estão desabilitados
      this.selectedIds = this.pedidos
        .filter((pedido) => this.disableCheckbox(pedido)) // Verifica se o pedido está desabilitado
        .map((pedido) => pedido.numero_pedido);
    } else {
      this.selectedIds = [];
    }
  }

  valorDesconto(v) {
    this.descontoValor = v;
  }
  desconto() {
    const valorNumerico = Number(this.descontoValor);

    if (valorNumerico >= 0 && valorNumerico <= 100) {
      this.pedidoService.aplicaDesconto(
        {
          pedido: this.descontoId,
          descontoPercent: valorNumerico / 100,
        },
        this.callbackDiscount.bind(this),
        this.callbackError.bind(this)
      );
    } else {
      Swal.fire(
        "",
        $localize`por favor, insira um valor de desconto válido.`,
        "warning"
      );
    }
  }

  callbackDiscount(resp) {
    Swal.fire(
      $localize`Pedido`,
      $localize`Desconto Aplicado com sucesso!`,
      "success"
    );
    this.getPedidos();
  }

  callbackDiscountError(resp) {
    Swal.fire(
      $localize`Pedido`,
      $localize`Erro ao aplicar desconto!`,
      "warning"
    );
    this.getPedidos();
  }
  async aproveAll() {
    let error = 0;
    let success = 0;

    const aprova = () => {
      success++;
    };

    const erro = () => {
      error++;
      Swal.fire(
        $localize`Histórico`,
        $localize`Algo deu errado em um dos pedidos. Tente novamente mais tarde`,
        "warning"
      );
    };

    // Array de promessas para garantir que todas as aprovações sejam esperadas
    const promises = this.selectedIds.map((id) => {
      return new Promise<void>((resolve, reject) => {
        this.pedidoService.aprovarPedido(
          id,
          true,
          false,
          () => {
            aprova();
            resolve();
          },
          () => {
            erro();
            reject();
          }
        );
      });
    });

    // Aguarda que todas as promessas sejam resolvidas
    await Promise.all(promises);

    // Exibe a mensagem após o término de todas as operações
    if (success === this.selectedIds.length) {
      this.toggleSelectAll(false);
      Swal.fire(
        $localize`Histórico`,
        $localize`Todos os pedidos aprovados com sucesso`,
        "success"
      );
      this.getPedidos();
    } else if (error > 0) {
      Swal.fire(
        $localize`Histórico`,
        $localize`Alguns pedidos falharam na aprovação`,
        "warning"
      );
    }
  }

  onSelectUsuario(event: TypeaheadMatch): void {
    this.formSearch.controls.usuario.setValue(event.item.id);
    $("#usuario").blur();
    $("#usuario").removeClass("is-valid is-invalid");
    $("#usuario").addClass("is-valid");
    $("#btnFormSearch").focus();
  }

  typeaheadNoResultsUsuario(event: boolean): void {
    this.formSearch.controls.usuario.setValue("");
    $("#usuario").removeClass("is-valid is-invalid");
    $("#usuario").addClass("is-invalid");
  }
}
